import { useState } from 'react';
import { ratingApi } from '@/services/api';

interface Props {
  open: boolean;
  onClose: () => void;
  rateeId: number;
  listingType: string;
  listingId: number;
  onDone?: () => void;
}

export default function RatingModal({ open, onClose, rateeId, listingType, listingId, onDone }: Props) {
  const [score, setScore] = useState(5);
  const [comment, setComment] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async () => {
    setErr('');
    setBusy(true);
    try {
      await ratingApi.submit(rateeId, { score, comment, listingType, listingId });
      onDone?.();
      onClose();
    } catch {
      setErr('提交失败，需先与对方沟通后才能评价');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-foreground-900/40" onClick={onClose}>
      <div className="bg-background-50 rounded-lg p-6 w-[90%] max-w-md" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">评价对方</h3>
        <div className="flex gap-1 mb-4">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              onClick={() => setScore(n)}
              className={`text-2xl cursor-pointer ${n <= score ? 'text-primary-500' : 'text-background-300'}`}
              aria-label={`${n} 星`}
            >
              ★
            </button>
          ))}
        </div>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          maxLength={500}
          placeholder="说说你的合作体验（选填）"
          className="w-full border border-background-300 rounded-md p-3 text-sm resize-none h-24 mb-3"
        />
        {err && <p className="text-accent-600 text-sm mb-3">{err}</p>}
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm text-foreground-500 cursor-pointer">取消</button>
          <button
            onClick={submit}
            disabled={busy}
            className="px-4 py-2 text-sm bg-primary-500 text-background-50 rounded-md cursor-pointer disabled:opacity-50"
          >
            {busy ? '提交中…' : '提交评价'}
          </button>
        </div>
      </div>
    </div>
  );
}
